import {Inject, Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {API_URL} from "lib-base";
import {IGetSolicitudActividades} from "../../shared/interfaces/pqrsdf";

@Injectable({
  providedIn: 'root'
})
export class SolicitudPqrsdActividadesService {

  private baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/solicitud-actividades`;
  }

  getActividadesByRadicado(radicado: string): Observable<IGetSolicitudActividades[]> {
    return this.http.get<IGetSolicitudActividades[]>(`${this.baseUrl}/public/actividades/${radicado}`)
  }
}
